<template>
  <div class="graphic-editor">
    <editor v-model="content" :init="setting" />
    <!-- <footer>
      <el-button size="small" @click="addText">添加文字</el-button>
      <el-button size="small" @click="changeColor">修改字体颜色</el-button>
    </footer> -->
  </div>
</template>
<script>
import axios from '@/common/utils/axios'
import Editor from '@tinymce/tinymce-vue'
import tinymce from 'tinymce/tinymce' // tinymce默认hidden，不引入则不显示编辑器
import config from '@/common/js/graphic-editor.js'
import { onBeforeRouteLeave } from 'vue-router'
import { onMounted, ref } from 'vue'
// import { ElButton } from 'element-plus'
export default {
  components: { Editor },
  props: {
    desc: {
      type: Object,
      default: () => {}
    }
  },
  setup (props) {
    const save = ref(false)

    /**
     * 初始化编辑器相关
     */
    const content = ref('')
    let contentCopy = ''
    // 图片上传成功回调
    const imageCb = (url, size) => {
      axios('/admin/desc/image/upload', {
        descId: props.desc.id,
        url: url
      }).then(() => { }).catch(_ => { })
    }
    // 视频上传成功回调
    const videoCb = (url, size, duration) => {
      axios('/admin/desc/video/upload', {
        descId: props.desc.id,
        url: url,
        size: size ? size / 1024 : '',
        duration: duration
      }).then(() => { }).catch(_ => { })
    }
    const setting = {
      ...config,
      images_upload_handler: (blobInfo, success, failure, progress) => {
        config.images_upload_handler(blobInfo, success, failure, progress, props.desc.iid, imageCb)
      },
      file_picker_callback: (callback, value, meta) => {
        config.file_picker_callback(callback, value, meta, props.desc.iid, videoCb)
      },
      init_instance_callback: function () {
        config.init_instance_callback()
        if (props.desc.text) {
          insertContent(props.desc.text)
        }
        contentCopy = content.value
      }
    }
    onMounted(() => {
      tinymce.init({
        plugins: ['quickbars'],
        toolbar: false,
        menubar: false,
        inline: true
      })
    })

    /**
     * 插入dom元素至编辑器
     */
    const insertContent = (htmlTemplate) => {
      tinymce.editors[0].insertContent(htmlTemplate)
    }
    // const addText = () => {
    //   tinymce.editors[0].setContent('这是一段文字')
    // }
    // const changeColor = () => {
    //   tinymce.editors[0].setContent('test')
    // }

    onBeforeRouteLeave((to, from, next) => {
      if (save.value || content.value === contentCopy) {
        next()
        return
      }
      window.$confirm('是否确认放弃编辑').then(() => {
        next()
      }).catch(_ => {})
    })

    return {
      content,
      setting,
      tinymce,
      insertContent
    }
  }
}
</script>
<style lang="scss" scoped>
.graphic-editor {
  border-radius: 3px;
  background-color: #fff;
  :deep .tox-tinymce{
    height: 100% !important;
  }
  footer {
    text-align: center;
    .el-button{
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
}
</style>
